import { render, staticRenderFns } from "./PublishingContractsGroupDialog.vue?vue&type=template&id=7cda0f74"
import script from "./PublishingContractsGroupDialog.vue?vue&type=script&lang=js"
export * from "./PublishingContractsGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports